module.exports = "/_next/static/images/f35003b3d8cc9da74b5be4e299951fc6-location-icon.svg";